// Mesajele din profilul elevului (erorile, confirmările) merg în bula de sus (AlertPills), nu sub
// câmpuri: fiecare filă cheamă useProfileAlert cu textul ei; când textul apare (sau se schimbă),
// ajunge în coada profilului (StudentInfoPopup: pushAlert, prin StudentInfoContext).
import { useContext, useEffect } from "react";

import { StudentInfoContext } from "./StudentInfoContext";

export function useProfileAlert(text, type = "error") {
   const { pushAlert } = useContext(StudentInfoContext) || {};
   const message = String(text || "").trim();
   useEffect(() => {
      if (message && typeof pushAlert === "function") pushAlert(type, message);
   }, [message, type, pushAlert]);
}
